import React, { CSSProperties, useContext } from "react";
import { ActionBarConfig } from "common/utils/actionBar";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { SideNavWidthContext } from "../../SideNav";
import { ActionBar } from "../ActionBar/ActionBar";
import { useTableRowsSelectionState } from "../Tables/RowSelectionProvider";
import { ActionBarWrapperContainer } from "./__styles__/ActionBarWrapper";

interface ActionBarWrapperProps {
  actionBarConfig: ActionBarConfig;
  refetchTable: () => void;
}

export function ActionBarWrapper({
  actionBarConfig,
  refetchTable,
}: ActionBarWrapperProps) {
  const { state, resetRowSelection } = useTableRowsSelectionState();
  const { width } = useWindowSize();
  const { width: sideNavWidth } = useContext(SideNavWidthContext);

  if (state.totalSelected === 0) {
    return null;
  }

  const onSubmit = () => {
    resetRowSelection();
    refetchTable();
  };

  const hasSidebar = width > 1024;
  const leftOffset = hasSidebar ? sideNavWidth / 2 : 0;

  return (
    <ActionBarWrapperContainer
      hasSidebar={hasSidebar}
      style={
        {
          "--left-offset": `${leftOffset}px`,
        } as CSSProperties
      }
    >
      <ActionBar actionBarConfig={actionBarConfig} onSubmit={onSubmit} />
    </ActionBarWrapperContainer>
  );
}
